import { ReactSelectValue } from 'types/forms';
import { BillingServiceName, BillingPrice } from 'services/backend/billing';

export const getOptionPrice = (
  optionName: BillingServiceName,
  activePrices: BillingPrice[] | undefined,
) => {
  const optionPricing = activePrices?.find(
    (option) => option.priceName === optionName,
  );
  return optionPricing?.price;
};

export const getOptionLabel = (
  optionValue: string,
  options: ReactSelectValue<string>[] | undefined,
) => options?.find((option) => option.value === optionValue)?.label;
